<template>
  <div id="Delivery">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>

    <b-modal id="modalExport" size="xl" no-close-on-backdrop>
      <template #modal-header="{ close }">
        <h5>ใบชำระสินค้า {{ invoiceData.deliverDoc }}</h5>
        <b-button size="sm" variant="secondary" @click="close()">
          <f-icon icon="window-close"></f-icon> ปิดหน้าต่าง
        </b-button>
      </template>

      <template #modal-footer>
        <div class="w-100">
            <!-- <b-overlay :show="!dataUpdate" rounded="sm"> -->
              <template v-if="invoiceData.status === 'รอตรวจสอบ'">
                <b-button :disabled="!dataUpdate" variant="danger" class="float-right my-2" @click="delConfirm(invoiceData)">
                  <f-icon icon="times"></f-icon> ยกเลิกใบชำระสินค้า
                </b-button>
                <!-- <b-button variant="success" class="float-right m-2" v-b-modal.modal-confirm v-if="userData.userType === 'A' && slipItem.length > 0"> -->
                <b-button :disabled="!dataUpdate" variant="success" class="float-right m-2" v-b-modal.modal-confirm v-if="userData.userType === 'A'">
                  <f-icon icon="check"></f-icon> อนุมัติใบชำระสินค้า
                </b-button>
              </template>
            <!-- </b-overlay> -->
          </div>
      </template>

      <template #default=" {} ">
          <template v-if="!dataExportReady">
            <div class="text-center">
              <f-icon icon="spinner" pulse></f-icon>
            </div>
          </template>
          <!-- <b-collapse id="cl-alert" v-model="dataReady"> -->
          <template v-if="dataExportReady">
            <b-card>
              <b-card-body class="p-2">
                <p for="form_name" class="mb-1"><b>ชื่อผู้รับ:</b> {{ invoiceData.recipientName }}</p>
                <!-- <b-form-input id="form_name" v-model="invoiceData.recipientName" type="text" autocomplete="off" class="mb-2"></b-form-input> -->
                <p for="form_tel" class="mb-1"><b>เบอร์โทรศัพท์ผู้รับ:</b> {{ invoiceData.recipientTelephone }}</p>
                <!-- <b-form-input id="form_tel" v-model="invoiceData.recipientTelephone" type="tel" autocomplete="off" class="mb-2" maxlength="10"></b-form-input> -->
                <label for="form_addr"><b>ที่อยู่จัดส่ง:</b> </label>
                <b-form-textarea id="form_addr" plaintext max-rows="6" class="mb-2" v-model="invoiceData.recipientAddress" rows="2"></b-form-textarea>

                <p for="form_transportType" class="mb-1"><b>บริษัทขนส่งสำหรับจัดส่ง:</b> {{ invoiceData.transportType }}</p>
                <!-- <b-form-input id="form_transportType" v-model="invoiceData.transportType" type="text" autocomplete="off" class="mb-2" placeholder="เช่น ไปรษณีย์ไทย Kerry J&T"></b-form-input> -->
                <p for="form_paymentType" class="mb-1"><b>ชำระผ่านช่องทาง:</b> {{ invoiceData.paymentType }}</p>
                <!-- <b-form-input id="form_paymentType" v-model="invoiceData.paymentType" type="text" autocomplete="off" class="mb-2" placeholder="ธนาคารที่โอนเงินเข้ามา"></b-form-input> -->
                <p for="form_remark" class="mb-1"><b>หมายเหตุ:</b> {{ invoiceData.remark }}</p>
                <!-- <b-form-input id="form_remark" v-model="invoiceData.remark" type="text" autocomplete="off" class="mb-2" placeholder="วลีช่วยจำ, รายละเอียดพิเศษ"></b-form-input> -->
                <br>

                <!-- <template v-if="invoiceData.senderName">
                  <p for="sender_name" class="mb-1"><b>ชื่อผู้ส่ง:</b> {{ invoiceData.senderName }}</p>
                  <p for="sender_tel" class="mb-1"><b>เบอร์โทรศัพท์ผู้ส่ง:</b> {{ invoiceData.senderTelephone }}</p>
                  <label for="sender_addr"><b>ที่อยู่ผู้ส่ง:</b> </label>
                  <b-form-textarea id="sender_addr" plaintext max-rows="6" class="mb-2" v-model="invoiceData.senderAddress" rows="6"></b-form-textarea>
                  <br>
                </template> -->

                <p><b>รายการสั่งออก</b></p>
                <b-overlay
                  id="overlay-dataTrackingReady"
                  :show="!dataTrackingReady"
                  variant="transparent"
                  :opacity="0.95"
                  blur="4px"
                  rounded="sm"
                >
                  <template #overlay>
                    <div class="text-center">
                      <h4 id="cancel-label">กำลังเรียกดูข้อมูล</h4>
                    </div>
                  </template>

                  <b-table striped bordered small responsive table-variant="success"
                    :items="trackingItem" :fields="trackingFields"
                    class="table-mini">

                    <template #cell(price)="data">
                      {{ data.item.priceByKilo > data.item.priceByQueue ? data.item.priceByKilo : data.item.priceByQueue }}
                    </template>

                    <template #custom-foot=" {} ">
                      <!-- <b-tr v-if="trackingItem.length > 1"> -->
                      <b-tr class="font-weight-bold" v-if="trackingItem.length >= 1" style="background-color: #57B06B;">
                        <b-td colspan="3">รวม</b-td>
                        <b-td>{{ trackingItem.map(x => parseFloat(x.amount)).reduce((a, b) => a + b) }}</b-td>
                        <b-td>{{ trackingItem.map(x => parseFloat(x.totalWeight)).reduce((a, b) => a + b) }}</b-td>
                        <b-td>{{ trackingItem.map(x => parseFloat(x.totalQueue)).reduce((a, b) => a + b) }}</b-td>
                        <b-td colspan="3"></b-td>
                        <b-td>{{ invoiceData.amountTracking }}</b-td>
                      </b-tr>
                      <b-tr v-if="pointSale > 0">
                        <b-td  colspan="9" class="text-right">ใช้แต้มส่วนลด <img :src="require('@/assets/svg/chip_point.svg')" class="icon-svg"/></b-td>
                        <b-td>-{{ pointSale }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td colspan="9" class="text-right">ค่าบริการโกดัง</b-td>
                        <b-td>50</b-td>
                      </b-tr>
                      <b-tr v-if="invoiceData.amountDelivery > 0">
                        <b-td colspan="9" class="text-right"><i class="text-danger">(ราคาข้างต้นเป็นเพียงราคาประมาณการ ค่าใช้จ่ายจริงจะคิดตามบิลขนส่งและหักลบคืนเป็นยอดเงินในระบบ)</i> ค่าจัดส่งในไทย</b-td>
                        <b-td>{{ invoiceData.amountDelivery }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td colspan="9" class="text-right">ราคารวมทั้งหมด</b-td>
                        <b-td>{{ (invoiceData.amountTotal !== invoiceData.amountPaid ? invoiceData.amountTotal : ( invoiceData.amountTracking !== 0 ? invoiceData.amountPaid : invoiceData.amountPaid + invoiceData.amountDelivery)) - pointSale }}</b-td>
                        <!-- <b-td>{{ invoiceData.amountTotal !== invoiceData.amountPaid ? invoiceData.amountTotal : (invoiceData.amountPaid + invoiceData.amountDelivery) }}</b-td> -->
                      </b-tr>
                    </template>

                  </b-table>
                </b-overlay>

                <template v-if="invoiceData.status === 'อนุมัติการชำระ'">
                  <p><b>ประวัติการแจ้งชำระเงินที่เกี่ยวกับรายการสั่งซื้อนี้</b> ({{ slipItem.length }} รายการ)</p>
                  <b-overlay
                    id="overlay-dataSlipReady"
                    :show="!dataSlipReady"
                    variant="transparent"
                    :opacity="0.95"
                    blur="4px"
                    rounded="sm"
                  >
                    <template #overlay>
                      <div class="text-center">
                        <h4 id="cancel-label">กำลังเรียกดูข้อมูล</h4>
                      </div>
                    </template>

                    <b-table striped bordered small responsive
                      :items="slipItem" :fields="slipFields" table-variant="info"
                      show-empty empty-text="ไม่พบการชำระเงิน"
                      class="table-mini">

                      <template #cell(createSliptime)="data">
                        {{ data.value.date }} {{ data.value.time }}
                      </template>

                      <template #cell(showDetails)="row">
                        <b-button size="sm" @click="row.toggleDetails" variant="info">
                          <f-icon icon="receipt"></f-icon> {{ row.detailsShowing ? 'ซ่อน' : 'แสดง' }}สลิป
                        </b-button>
                      </template>

                      <template #row-details="row">
                          <b-row class="my-2">
                            <b-col>
                              <b-img thumbnail fluid width="300" center
                                :src="row.item.pictureSlip" v-if="row.item.pictureSlip"
                                alt="หลักฐานการโอนเงิน"></b-img>
                            </b-col>
                          </b-row>
                      </template>

                    </b-table>
                  </b-overlay>
                </template>

                <template v-if="invoiceData.pictureSlip">
                  <p><b>บิลขนส่ง</b></p>

                  <b-img class="animate__animated animate__heartBeat" thumbnail fluid width="400" center :src="invoiceData.pictureSlip" alt="หลักฐานบิลขนส่ง"></b-img>
                </template>

              </b-card-body>
            </b-card>
          </template>
      </template>
    </b-modal>

    <b-modal
      id="modal-confirm"
      title="ยืนยันวันที่ส่งออกพัสดุ"
      cancel-title="ย้อนกลับ" cancel-variant="danger"
      ok-title="ยืนยันการอนุมัติ" ok-variant="success"
      no-close-on-backdrop
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleUpdate"
    >
      <b-form-group
        label="วันที่ส่งออกพัสดุ"
        label-for="Deliver"
      >
        <b-form-datepicker id="Deliver"
          reset-button close-button locale="th" placeholder="เลือกวันที่ส่งออกพัสดุ"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          class="mb-2" v-model="formConfirm.deliver"></b-form-datepicker>
      </b-form-group>
      <b-form-group
        label="ค่าส่งจีน + ค่าบริการโกดัง"
        label-for="form_amount"
      >
        <b-form-input id="form_amount" autocomplete="off" readonly :value="invoiceData.amountCTransport" type="number"></b-form-input>
      </b-form-group>

      <b-form-group
        label="ค่าส่งสินค้าในไทย"
        label-for="form_amount_deliver"
      >
        <b-form-input id="form_amount_deliver" autocomplete="off" readonly :value="invoiceData.amountDelivery" type="number"></b-form-input>
      </b-form-group>

    </b-modal>

    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">

          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <alert-card></alert-card>
          <h2>รายการส่งออกสินค้า</h2>
          <b-row class="mb-3">
            <b-col sm="6" class="mb-2">
              <b-card bg-variant="light">
                <b-card-text class="text-center">
                  ติดต่อสอบถามแอดไลน์ LICM Cargo

                  <b-img center
                    :src="require('@/assets/img/QRWEBLICM.jpg')"
                    width="180px"
                    height="180px" class="my-2"></b-img>

                  <a href="https://lin.ee/NUGqMkp">
                    <img src="https://scdn.line-apps.com/n/line_add_friends/btn/th.png" alt="เพิ่มเพื่อน" height="30" border="0">
                  </a>
                </b-card-text>
              </b-card>
            </b-col>
            <b-col sm="6">

              <b-card body-class="p-0">
                <b-card-body>
                  <!-- @submit="onSubmit" -->
                  <b-form @submit="onSubmit">
                    <b-card-text>
                      <template v-if="userData.userType === 'A'">
                        <label for="form_userCode" class="mb-1">รหัสสมาชิก:</label>
                        <b-input-group class="mb-2">
                          <b-form-input id="form_userCode" v-model="form.userCode" type="text" autocomplete="off"></b-form-input>
                        </b-input-group>
                      </template>

                      <label for="form_deliverDoc" class="mb-1">รหัสใบชำระสินค้า:</label>
                      <b-input-group class="mb-2">
                        <b-form-input id="form_deliverDoc" v-model="form.deliverDoc" type="text" autocomplete="off"></b-form-input>
                        <b-input-group-append>
                          <!-- @click="onSubmit" -->
                          <b-button variant="success" type="submit">ค้นหา</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-card-text>
                  </b-form>
                  <hr>
                  <b-button variant="secondary" block :to="{ path: '/User/Export' }" replace><f-icon icon="dolly"></f-icon> สั่งออกสินค้า</b-button>
                  <!-- <b-button variant="purple" block :to="{ path: '/User/Payment' }" replace><f-icon icon="file-invoice-dollar"></f-icon> แจ้งชำระเงิน</b-button> -->
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>

          <!-- <b-skeleton-table
            :rows="4"
            :columns="3"
            :table-props="{ striped: true }"
            v-if="!dataReady"
          ></b-skeleton-table> -->

          <template v-if="dataDeliveryReady">
            <h4><b class="text-primary">รายการจัดส่งสำเร็จ</b></h4>
            <b-table striped responsive
              :items="delivery_items" :fields="delivery_fields"
              :current-page="delivery_currentPage"
              :per-page="perPage"
              head-variant="light"
              :tbody-tr-class="rowSuccessClass"
              show-empty
              empty-text="ไม่พบข้อมูล"
              class="table-mini">

              <template #cell(actions)="data">
                <a v-b-tooltip.hover title="เรียกดูข้อมูล" @click="openDataInvoice(data.item)">
                  <f-icon icon="file-alt"></f-icon>
                </a>
              </template>

              <template #cell(createDatetime)="data">
                {{ data.value.date }}<br>{{ data.value.time }}
              </template>

              <template #cell(lastDatetime)="data">
                {{ data.value.date }}<br>{{ data.value.time }}
              </template>

              <template #cell(picDelivery)="data">
                <b-img center width="40" :src="data.item.pictureSlip" :alt="'บิลขนส่ง ' + data.item.deliverDoc"></b-img>
              </template>

            </b-table>
            <b-pagination
              v-model="delivery_currentPage"
              pills first-number last-number
              v-if="delivery_totalRows > perPage"
              :total-rows="delivery_totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
            ></b-pagination>
            <hr>
          </template>

          <template v-if="dataReady">

            <template v-if="userData.userType === 'A'">
              <h4>รายการสั่งออก</h4>
              <b-table striped responsive
                :items="items" :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                show-empty
                empty-text="ไม่พบข้อมูล"
                :busy="!dataReady"
                class="table-mini">

                <template #cell(actions)="data">
                  <a v-b-tooltip.hover title="เรียกดูข้อมูล" @click="openDataInvoice(data.item)">
                    <f-icon icon="file-alt"></f-icon>
                  </a>
                </template>

                <template #cell(createDatetime)="data">
                  {{ data.value.date }}<br>{{ data.value.time }}
                </template>

                <template #cell(lastDatetime)="data">
                  {{ data.value.date }}<br>{{ data.value.time }}
                </template>

              </b-table>
              <b-pagination
                v-model="currentPage"
                pills first-number last-number
                v-if="totalRows > perPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
              ></b-pagination>

              <hr>
            </template>

            <h4><b class="text-success">รายการอนุมัติการสั่งออก</b></h4>
            <b-table striped responsive
              :items="approved_items" :fields="fields"
              :current-page="approved_currentPage"
              :per-page="perPage"
              head-variant="dark"
              :tbody-tr-class="rowSuccessClass"
              show-empty
              empty-text="ไม่พบข้อมูล"
              :busy="!dataReady"
              class="table-mini">

              <template #cell(actions)="data">
                <a v-b-tooltip.hover title="เรียกดูข้อมูล" @click="getDocInvoices(data.item)">
                  <f-icon icon="file-alt"></f-icon>
                </a>
              </template>

              <template #cell(createDatetime)="data">
                {{ data.value.date }}<br>{{ data.value.time }}
              </template>

              <template #cell(lastDatetime)="data">
                {{ data.value.date }}<br>{{ data.value.time }}
              </template>

            </b-table>
            <b-pagination
              v-model="approved_currentPage"
              pills first-number last-number
              v-if="approved_totalRows > perPage"
              :total-rows="approved_totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
            ></b-pagination>

            <template v-if="userData.userType !== 'A'">
              <hr>

              <h4>รายการสั่งออก</h4>
              <b-table striped responsive
                :items="items" :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                show-empty
                empty-text="ไม่พบข้อมูล"
                :busy="!dataReady"
                class="table-mini">

                <template #cell(actions)="data">
                  <a v-b-tooltip.hover title="เรียกดูข้อมูล" @click="openDataInvoice(data.item)">
                    <f-icon icon="file-alt"></f-icon>
                  </a>
                </template>

                <template #cell(createDatetime)="data">
                  {{ data.value.date }}<br>{{ data.value.time }}
                </template>

                <template #cell(lastDatetime)="data">
                  {{ data.value.date }}<br>{{ data.value.time }}
                </template>

              </b-table>
              <b-pagination
                v-model="currentPage"
                pills first-number last-number
                v-if="totalRows > perPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
              ></b-pagination>
            </template>

          </template>

        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "Delivery",
  components: {
    'left-menu': MenuBar,
    'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.getDataUser()
    await this.getDataInvoices()
    await this.getDataDelivery()
    if (this.$route.query.Doc) {
      let dt = { deliverDoc : this.$route.query.Doc }
      await this.getDocInvoices(dt)
    }
  },
  data() {
    return {
      fields: [
        { key: 'deliverDoc', sortable: true, label: 'รหัสใบชำระสินค้า', thClass: 'py-2' },
        { key: 'userCode', sortable: true, label: 'รหัสสมาชิก', thClass: 'py-2 text-center', tdClass: 'text-center font-weight-bold' },
        { key: 'createDatetime', label: 'วันที่สร้าง', thClass: 'py-2 text-center', tdClass: 'text-center' },
        { key: 'lastDatetime', label: 'วันที่ทำรายการ', thClass: 'py-2 text-center', tdClass: 'text-center' },
        { key: 'transportType', label: 'ประเภทการจัดส่ง', thClass: 'py-2 text-center' },
        { key: 'remark', label: 'หมายเหตุ', thClass: 'py-2 text-center', tdClass: 'font-weight-light' },
        { key: 'amountPaid', label: 'ราคารวม', thClass: 'py-2 text-center' },
        { key: 'status', sortable: true, label: 'สถานะ', thClass: 'py-2 text-center', tdClass: 'text-center font-weight-bold' },
        { key: 'actions', label: 'จัดการ', thClass: 'py-2 text-center', tdClass: 'text-center' }
      ],
      delivery_fields: [
        { key: 'deliverDoc', sortable: true, label: 'รหัสใบชำระสินค้า', thClass: 'py-2' },
        { key: 'userCode', sortable: true, label: 'รหัสสมาชิก', thClass: 'py-2 text-center', tdClass: 'text-center font-weight-bold' },
        { key: 'createDatetime', label: 'วันที่สร้าง', thClass: 'py-2 text-center', tdClass: 'text-center' },
        { key: 'lastDatetime', label: 'วันที่ทำรายการ', thClass: 'py-2 text-center', tdClass: 'text-center' },
        { key: 'transportType', label: 'ประเภทการจัดส่ง', thClass: 'py-2 text-center' },
        { key: 'remark', label: 'หมายเหตุ', thClass: 'py-2 text-center', tdClass: 'font-weight-light' },
        { key: 'picDelivery', label: 'บิลขนส่ง', thClass: 'py-2 text-center', tdClass: 'p-1'  },
        { key: 'status', label: 'สถานะ', thClass: 'py-2 text-center', tdClass: 'text-center font-weight-bold' },
        { key: 'actions', label: 'จัดการ', thClass: 'py-2 text-center', tdClass: 'text-center' }
      ],
      items: [],
      approved_items: [],
      delivery_items: [],

      perPage: 10,
      totalRows: 1,
      currentPage: 1,

      approved_totalRows: 1,
      approved_currentPage: 1,

      delivery_totalRows: 1,
      delivery_currentPage: 1,

      invoiceData: {
        deliverDetailId: '',
        deliverDoc: '',
        userName: '',
        userCode: '',
        recipientName: '',
        recipientAddress: '',
        recipientTelephone: '',
        transportType: '',
        amountPaid: '',
        balanceInSystem: '',
        paymentType: '',
        remark: '',
        senderName: '',
        senderAddress: '',
        senderTelephone: '',
        CREATE_DATE: '',
        LAST_DATE: '',
        CREATE_USER: '',
        LAST_USER: '',
        RECORD_STATUS: 'N',
        status: ''
      },
      trackingFields: [
        { key: 'suppliesCode', label: 'รหัสพัสดุ' },
        { key: 'mnemonicPhrase', label: 'วลีช่วยจำ' },
        { key: 'category', label: 'ประเภท' },
        { key: 'amount', label: 'จำนวน' },
        { key: 'totalWeight', label: 'น้ำหนัก' },
        { key: 'totalQueue', label: 'คิว.' },
        { key: 'InWarehouse', label: 'เข้าโกดัง' },
        { key: 'OutWarehouse', label: 'ออกโกดัง' },
        { key: 'InThailand', label: 'ถึงไทย' },
        { key: 'price', label: 'ราคา' },
      ],
      slipFields: [
        { key: 'createSliptime', label: 'แจ้งชำระมาเมื่อ' },
        { key: 'transferDate', label: 'วันที่ชำระ' },
        { key: 'transferTime', label: 'เวลาชำระ' },
        { key: 'amount', label: 'จำนวนเงิน' },
        { key: 'noteSlip', label: 'รายละเอียดเพิ่มเติม' },
        { key: 'showDetails', label: 'หลักฐานการชำระ' }
      ],
      trackingItem: [],
      slipItem: [],
      userData: {
        userName: '',
        userCode: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      form: {
        deliverDoc: '',
        userCode: ''
      },
      formConfirm: {
        deliverDoc: "",
        userName: "",
        status: "อนุมัติการสั่งออก",
        deliver: "",
        amount: 0,
        amountPoint: 0,
        LAST_USER: ""
      },
      pointSale: 0,
      dataReady: true,
      dataSlipReady: true,
      dataTrackingReady: true,
      dataUpdate: true,
      dataDeliveryReady: false,
      dataExportReady: false
    };
  },
  methods: {
    formatDate (dtDate) {
      if (dtDate) {
        var strDateShort = dtDate.split('-')[2] + '/' + dtDate.split('-')[1] + '/' + dtDate.split('-')[0].substring(2, 4)
        return strDateShort
      } else {
        return ''
      }
    },
    rowSuccessClass (item, type) {
      if (!item || type !== 'row') return
      if (item.status === 'อนุมัติการสั่งออก') return 'table-success'
      if (item.status === 'อนุมัติการชำระ') return 'table-info'
      if (item.status === 'จัดส่งสำเร็จ') return 'table-primary'
    },
    getDataUser () {
      this.dataReady = false;
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser
        this.dataReady = true
      } else {
        this.$router.push('/Login')
      }
    },
    onSubmit (event) {
      event.preventDefault()
      this.getDataInvoices()
      this.getDataDelivery()
    },
    getDataInvoices () {
      this.dataReady = false
      this.totalRows = 0
      this.approved_totalRows = 0
      this.items = []
      this.approved_items = []

      let uc = this.userData.userType === 'A' ? this.form.userCode : this.userData.userCode
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Deliver_detail/Deliver_detail_list?userName=' +
          this.userData.userName +
          '&userType=' +
          this.userData.userType +
          '&userCode=' +
          uc +
          '&deliverDoc=' +
          this.form.deliverDoc,
          {
            headers: this.getHeaderAPI('Deliver_detail_list', this.userData.userName)
          }
        )
        .then((response) => {
          console.log('getDataInvoices', response.data)

          let rs = response.data
          if (rs.status === true){
            if (rs.data.length > 0) {
              // รายการปกติ
              // this.totalRows = rs.data.length
              for (let i = 0; i < rs.data.length; i++) {
                let invoiceData = rs.data[i]

                invoiceData.createDatetime = this.formatDateTime(rs.data[i].CREATE_DATE)
                invoiceData.lastDatetime = this.formatDateTime(rs.data[i].LAST_DATE)
                invoiceData.amountPaid = parseFloat(invoiceData.amountPaid)
                invoiceData.amountDelivery = parseFloat(invoiceData.amountDelivery)
                invoiceData.amountTracking = parseFloat(invoiceData.amountTracking)
                if (invoiceData.amountTracking !== 0) {
                  invoiceData.amountTotal = invoiceData.amountDelivery + invoiceData.amountTracking + 50
                  invoiceData.amountCTransport = invoiceData.amountTracking + 50
                } else {
                  invoiceData.amountTotal = invoiceData.amountPaid
                  invoiceData.amountCTransport = invoiceData.amountPaid
                }

                if (invoiceData.status === 'รอตรวจสอบ') {
                  this.items.push(invoiceData)
                } else if (invoiceData.status === 'จัดส่งสำเร็จ') {
                  if (this.userData.userType === 'A') {
                    this.approved_items.push(invoiceData)
                  }
                } else {
                  this.approved_items.push(invoiceData)
                }
              }

              this.totalRows = this.items.length
              this.approved_totalRows = this.approved_items.length

              // รายการชำระเงินแล้ว
              // this.approved_totalRows = rs.data_slip.length
              // for (let i = 0; i < rs.data_slip.length; i++) {
              //   let invoiceData = rs.data_slip[i]

              //   invoiceData.createDatetime = this.formatDateTime(rs.data_slip[i].CREATE_DATE)
              //   invoiceData.lastDatetime = this.formatDateTime(rs.data_slip[i].LAST_DATE)

              //   this.approved_items.push(invoiceData)
              // }
            }
          }

          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataInvoices error:', error)
          this.dataReady = true
          this.items = []
        });
    },
    getDataDelivery () {
      this.dataDeliveryReady = false
      this.delivery_totalRows = 0
      this.delivery_items = []

      let uc = this.userData.userType === 'A' ? this.form.userCode : this.userData.userCode
      if (this.userData.userType !== 'A') {

        axios
          .get(
            // eslint-disable-next-line quotes
            'https://licm-cargo.com/api/Deliver_detail/Deliver_detail_list?userName=' +
            this.userData.userName +
            '&userType=' +
            this.userData.userType +
            '&userCode=' +
            uc +
            '&status=จัดส่งสำเร็จ' +
            '&deliverDoc=' +
            this.form.deliverDoc,
            {
              headers: this.getHeaderAPI('Deliver_detail_list', this.userData.userName)
            }
          )
          .then((response) => {
            console.log('getDataDelivery', response.data)

            let rs = response.data
            if (rs.status === true){
              if (rs.data.length > 0) {
                // รายการปกติ
                // this.totalRows = rs.data.length
                for (let i = 0; i < rs.data.length; i++) {
                  let invoiceData = rs.data[i]

                  invoiceData.createDatetime = this.formatDateTime(rs.data[i].CREATE_DATE)
                  invoiceData.lastDatetime = this.formatDateTime(rs.data[i].LAST_DATE)
                  invoiceData.amountPaid = parseFloat(invoiceData.amountPaid)
                  invoiceData.amountDelivery = parseFloat(invoiceData.amountDelivery)
                  invoiceData.amountTracking = parseFloat(invoiceData.amountTracking)
                  if (invoiceData.amountTracking !== 0) {
                    invoiceData.amountTotal = invoiceData.amountDelivery + invoiceData.amountTracking + 50
                    invoiceData.amountCTransport = invoiceData.amountTracking + 50
                  } else {
                    invoiceData.amountTotal = invoiceData.amountPaid
                    invoiceData.amountCTransport = invoiceData.amountPaid
                  }
                  this.delivery_items.push(invoiceData)
                }

                this.delivery_totalRows = this.delivery_items.length
              }
            }

            this.dataDeliveryReady = true
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log('getDataDelivery error:', error)
            this.dataDeliveryReady = true
            this.items = []
          })

      }
    },
    getDocInvoices (dt) {
      this.dataExportReady = false
      // this.$bvModal.show('modalExport')
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Deliver_detail/Deliver_detail_list?userName=' +
          this.userData.userName +
          '&userType=' +
          this.userData.userType +
          '&status=' + (dt.status || "")  +
          '&deliverDoc=' +
          dt.deliverDoc,
          {
            headers: this.getHeaderAPI('Deliver_detail_list', this.userData.userName)
          }
        )
        .then((response) => {
          console.log('getDocInvoices', response.data)

          let rs = response.data
          if (rs.status === true){
            if (rs.data.length === 1) {
              let invoiceData = rs.data[0]

              invoiceData.createDatetime = this.formatDateTime(invoiceData.CREATE_DATE)
              invoiceData.lastDatetime = this.formatDateTime(invoiceData.LAST_DATE)
              invoiceData.amountPaid = parseFloat(invoiceData.amountPaid)
              invoiceData.amountDelivery = parseFloat(invoiceData.amountDelivery)
              invoiceData.amountTracking = parseFloat(invoiceData.amountTracking)
              if (invoiceData.amountTracking !== 0) {
                invoiceData.amountTotal = invoiceData.amountDelivery + invoiceData.amountTracking + 50
                invoiceData.amountCTransport = invoiceData.amountTracking + 50
              } else {
                invoiceData.amountTotal = invoiceData.amountPaid
                invoiceData.amountCTransport = invoiceData.amountPaid
              }

              this.openDataInvoice(invoiceData)
            }
          }
          this.dataExportReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDocInvoices error:', error)
          this.dataExportReady = true
        });
    },
    openDataInvoice (dt) {
      this.invoiceData = dt
      this.dataExportReady = true
      this.formConfirm.amount = parseFloat(dt.amountPaid)
      this.getDataTracking(dt.deliverDoc)
      if (dt.status === 'อนุมัติการชำระ') {
        this.getDataSlip(dt.deliverDoc)
      }
      this.$bvModal.show('modalExport')
    },
    resetModal () {
      this.formConfirm.deliverDoc = this.invoiceData.deliverDoc
      this.formConfirm.LAST_USER = this.userData.userName
      this.formConfirm.userName = this.userData.userName
      this.formConfirm.deliver = ''
    },
    handleUpdate(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      if (this.formConfirm.deliver) {
        this.formConfirm.amountPoint = this.pointSale
        this.onUpdate()
      } else {
        this.$swal("ผิดพลาด","กรุณาระบุวันที่ส่งออกพัสดุเพื่อยืนยัน","error")
      }
    },
    onUpdate () {
      this.dataUpdate = false
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Deliver_detail/Deliver_detail_update_status",
          this.formConfirm,
          {
            headers: this.getHeaderAPI('Deliver_detail_update_status', this.userData.userName)
          }
        )
        .then(async (response) => {
          console.log('delDataInvoice resp: ', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","อนุมัติใบชำระสินค้าเรียบร้อย","success")
            this.dataUpdate = true
            this.getDataInvoices()
            this.$nextTick(() => {
              this.$bvModal.hide('modal-confirm')
              this.$bvModal.hide('modalExport')
            })
          } else {
            console.log('registerUser Fail')
            this.$swal("ผิดพลาด","ไม่สามารถอนุมัติใบชำระสินค้าได้","error")
            this.dataUpdate = true
          }
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal("ผิดพลาด","ไม่สามารถอนุมัติใบชำระสินค้าได้","error")
          this.dataUpdate = true
        })
    },
    getDataTracking (deliverDoc) {
      this.dataTrackingReady = false
      this.pointSale = 0
      // let uc = this.userData.userType === 'A' ? this.form.userCode : this.userData.userCode
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Invoice_order/Invoice_export?userName=' +
          this.userData.userName +
          '&userType=' +
          this.userData.userType +
          '&deliverDoc=' +
          deliverDoc,
          {
            headers: this.getHeaderAPI('Invoice_export', this.userData.userName)
          }
        )
        .then((response) => {
          // console.log('getDataTracking', response.data)
          let rs = response.data
          this.trackingItem = []

          if (rs.status === true){
            if (rs.data.length > 0) {

              for (let i = 0; i < rs.data.length; i++) {
                var trackingData = rs.data[i]

                // trackingData.selectData = false
                trackingData.InWarehouse = this.formatDate(rs.data[i].InWarehouse)
                trackingData.OutWarehouse = this.formatDate(rs.data[i].OutWarehouse)
                trackingData.InThailand = this.formatDate(rs.data[i].InThailand)
                // trackingData.priceTracking = parseFloat(trackingData.priceByKilo || trackingData.priceByKilo)
                this.trackingItem.push(trackingData)
              }
              console.log('getDataTracking', this.trackingItem)

              if(rs.amountPoint) { this.pointSale = parseFloat(rs.amountPoint) }

            }
          }

          this.dataTrackingReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTracking error:', error)
          this.dataTrackingReady = true
          this.items = []
        });
    },
    getDataSlip (deliverDoc) {
      this.dataSlipReady = false;
      // let uc = this.userData.userType === 'A' ? this.form.userCode : this.userData.userCode
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Slip/Slip_list?userName=' +
          this.userData.userName +
          '&userType=' +
          this.userData.userType +
          '&deliverDoc=' +
          deliverDoc,
          {
            headers: this.getHeaderAPI('Slip_list', this.userData.userName)
          }
        )
        .then((response) => {
          // console.log('getDataSlip', response.data)
          let rs = response.data
          this.slipItem = []

          if (rs.status === true){
            if (rs.data.length > 0) {

              for (let i = 0; i < rs.data.length; i++) {
                var slipData = rs.data[i]

                // slipData.selectData = false
                slipData.createSliptime = this.formatDateTime(rs.data[i].CREATE_DATE)
                // slipData.priceTracking = parseFloat(slipData.priceByKilo || slipData.priceByKilo)
                this.slipItem.push(slipData)
              }
              console.log('getDataSlip', this.slipItem)
            }
          }

          this.dataSlipReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataSlip error:', error)
          this.dataSlipReady = true
          this.items = []
        });
    },
    editDataInvoice (dt) {
      console.log('editDataInvoice', dt)
    },
    delConfirm (dt) {
      this.$swal({
        title: 'ยืนยันการยกเลิกใบชำระสินค้า',
        text: 'คุณต้องการยกเลิกใบชำระสินค้า ' + dt.deliverDoc + ' ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ยืนยัน'
      }).then((result) => {
        if (result.isConfirmed) {
          this.delDataInvoice(dt.deliverDoc)
        }
      })
    },
    delDataInvoice (dt) {
      console.log('delDataInvoice Doc: ', dt)
      this.dataUpdate = false
      var LASTuserName = this.userData.userName
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Deliver_detail/Deliver_detail_delete",
          {
            deliverDoc: dt,
            userName: this.userData.userName,
            LAST_USER: LASTuserName
          },
          {
            headers: this.getHeaderAPI('Deliver_detail_delete', this.userData.userName)
          }
        )
        .then(async (response) => {
          console.log('delDataInvoice resp: ', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","ยกเลิกใบชำระสินค้าเรียบร้อย","success")
            // this.dataReady = true
            this.dataUpdate = true
            this.getDataInvoices()
            this.$bvModal.hide('modalExport')
          } else {
            console.log('registerUser Fail')
            this.$swal("ผิดพลาด","ไม่สามารถยกเลิกใบชำระสินค้าได้","error")
            this.dataUpdate = true
          }
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal("ผิดพลาด","ไม่สามารถยกเลิกใบชำระสินค้าได้","error")
          this.dataUpdate = true
        })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

div.language-bar {
  padding-top: 10px;
  padding-bottom: 10px;
}

.table-mini{
  font-size: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Delivery.vue